import { Injectable, inject } from '@angular/core';
import { CrudService } from '@shared/modules/crud/crud.service';
import { Sms } from './sms.service';
import { SnowflakeIdService } from '@core/services/snowflake-id.service';

@Injectable({
    providedIn: 'root',
})
export abstract class MessageService<T> {
    model = 'messages';
    crudService = inject(CrudService);
    idService = inject(SnowflakeIdService);

    create(message: T) {
        this.crudService.setModel(this.model);
        const id = this.idService.generateId();
        return this.crudService.create(id, message);
    }
}
